var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      staticClass: "learning-center-section",
      attrs: { id: "learning-center" },
    },
    [
      _c("section-header", {
        attrs: {
          "class-name": "learning-center-section__header",
          label: "Learning Center",
        },
      }),
      _vm._v(" "),
      _vm.displayVideos
        ? _c("content-slider", {
            staticClass: "learning-center-section__slider",
            attrs: { items: _vm.sliderData },
            scopedSlots: _vm._u(
              [
                {
                  key: "content-slider-item",
                  fn: function ({ data }) {
                    return [
                      _c("video-card", {
                        staticClass: "learning-center-section__video",
                        attrs: { video: data },
                      }),
                    ]
                  },
                },
              ],
              null,
              false,
              2116443145
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/components/LearningCenterSection.vue